<template>
    <div class="m-btn-close" :class="{'m-btn-close_translucent' : isTranslucent}"></div>
</template>

<script>
export default {
    name: "close",
    /**
     * ボタンの背景色が半透明か
     */
    props: {
        isTranslucent: {
            type: Boolean,
            require: false,
            default: false,
        }
    }
}
</script>

<style scoped lang="scss">
@use "../../../scss/v2/base/variables";
.m-btn-close {
    position: absolute;
    border-radius: 100%;
    box-shadow: 0 0 8px 0 rgba(variables.$color-black, variables.$opacity-10);
    margin: 12px;
    width: 32px;
    height: 32px;
    top: -25px;
    right: -25px;
    background: {
        color: variables.$color-white;
        image: url("/img/v2/icon/icon_close.svg");
        repeat: no-repeat;
        size: 18px;
        position: center;
    }
    // 半透明ボタン (meerkatなど)
    &_translucent {
        box-shadow: none;
        margin: 0;
        width: 36px;
        height: 36px;
        top: 6px;
        right: 6px;
        background: {
            color: rgba(variables.$color-black, variables.$opacity-30);
            image: url("/img/v2/icon/icon_close_white.svg");
            size: 20px;
        }
    }
}
</style>
